// Keep client-side email validation consistent with server rules:
// See api/src/lib/utils/contact.utils.ts
const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

export function isValidEmail(value: string | null | undefined): boolean {
  if (!value) return false
  return EMAIL_REGEX.test(value.trim())
}

/**
 * Lowercase and trim when valid, otherwise null.
 * Mirrors sanitizeEmail on the server for UX parity.
 */
export function sanitizeEmail(
  value: string | null | undefined
): string | null {
  if (!value) return null
  const trimmed = value.trim().toLowerCase()
  return isValidEmail(trimmed) ? trimmed : null
}

